/**
 * ScopedIncidents — School-context shortcut to the ecosystem-wide
 * Incidents Dashboard. Provides a one-click jump with the school context
 * pre-filtered.
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldAlert, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function ScopedIncidents({ tenantId }) {
  const navigate = useNavigate();
  return (
    <div className="space-y-3">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-sm">
            <ShieldAlert className="h-4 w-4" /> Behaviour Reports · this school
          </CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-slate-600 space-y-2">
          <p>Behaviour & incident reports filed within this school's context.</p>
          <Button
            onClick={() => navigate(`/admin/incidents?context_type=school&context_id=${tenantId}`)}
            data-testid="open-incidents-page"
          >
            <ExternalLink className="h-4 w-4 mr-1" /> Open Behaviour Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
